import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import dayjsImport from "./auth-service-tools36.js";
import { CalendarHeader } from "./auth-service-tools605.js";
import { useDatesContext } from "./auth-service-tools577.js";
import { Month } from "./auth-service-tools588.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
const defaultProps = {
  monthLabelFormat: "MMMM YYYY"
};
const MonthLevel = factory((_props, ref) => {
  const props = useProps("MonthLevel", defaultProps, _props);
  const {
    // Month settings
    month,
    locale,
    firstDayOfWeek,
    weekdayFormat,
    weekendDays,
    getDayProps,
    excludeDate,
    minDate,
    maxDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    __getDayRef,
    __onDayKeyDown,
    __onDayClick,
    __onDayMouseEnter,
    withCellSpacing,
    highlightToday,
    // CalendarHeader settings
    __preventFocus,
    __stopPropagation,
    nextIcon,
    previousIcon,
    nextLabel,
    previousLabel,
    onNext,
    onPrevious,
    onLevelClick,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    levelControlAriaLabel,
    withNext,
    withPrevious,
    // Other props
    monthLabelFormat,
    classNames,
    styles,
    unstyled,
    __staticSelector,
    size,
    static: isStatic,
    ...others
  } = props;
  const ctx = useDatesContext();
  const stylesApiProps = {
    __staticSelector: __staticSelector || "MonthLevel",
    classNames,
    styles,
    unstyled,
    size
  };

  const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !dayjsImport(month).endOf("month").isBefore(maxDate) : false;

  const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !dayjsImport(month).startOf("month").isAfter(minDate) : false;

  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, {
    "data-month-level": true,
    size,
    ref,
    ...others,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(CalendarHeader, {
      label: typeof monthLabelFormat === "function" ? monthLabelFormat(month) : dayjsImport(month).locale(locale || ctx.locale).format(monthLabelFormat),
      __preventFocus,
      __stopPropagation,
      nextIcon,
      previousIcon,
      nextLabel,
      previousLabel,
      onNext,
      onPrevious,
      onLevelClick,
      nextDisabled: _nextDisabled,
      previousDisabled: _previousDisabled,
      hasNextLevel,
      levelControlAriaLabel,
      withNext,
      withPrevious,
      ...stylesApiProps
    }), /* @__PURE__ */jsxRuntimeExports.jsx(Month, {
      month,
      locale,
      firstDayOfWeek,
      weekdayFormat,
      weekendDays,
      getDayProps,
      excludeDate,
      minDate,
      maxDate,
      renderDay,
      hideOutsideDates,
      hideWeekdays,
      getDayAriaLabel,
      __getDayRef,
      __onDayKeyDown,
      __onDayClick,
      __onDayMouseEnter,
      __preventFocus,
      __stopPropagation,
      static: isStatic,
      withCellSpacing,
      highlightToday,
      ...stylesApiProps
    })]
  });
});
MonthLevel.classes = { ...Month.classes,
  ...CalendarHeader.classes
};
MonthLevel.displayName = "@mantine/dates/MonthLevel";
export { MonthLevel };